import type { PresenceEventV1 } from '@/model/Presence.model';
import type { UserApiId } from '@/model/User.model';
import { SseStreamStatus, useSseStream } from './useSseStream';

interface UsePresenceStreamOutput {
  status: SseStreamStatus;
  isConnected: boolean;
  onlineUsers: Array<UserApiId>;
  lastTimestamp: string | null;
  connect: () => void;
  disconnect: () => void;
}

/**
 * Opens an SSE connection to the messaging service's presence endpoint,
 * tracking which users are currently online for the authenticated team.
 * Automatically reconnects with exponential backoff on connection failure.
 */
export const usePresenceStream = (): UsePresenceStreamOutput => {
  const { status, isConnected, lastEvent, connect, disconnect } = useSseStream<PresenceEventV1>(
    '/api/messaging/v1/presence/stream'
  );

  return {
    status,
    isConnected,
    onlineUsers: lastEvent?.users ?? [],
    lastTimestamp: lastEvent?.timestamp ?? null,
    connect,
    disconnect,
  };
};
